// Menu mobile
const elHeader = document.querySelector('#header');
const elHeaderMenuToggle = document.querySelector('#headerMenuToggle');

if (elHeader && elHeaderMenuToggle) {
    elHeaderMenuToggle.addEventListener("click", ()=>{
        if (!elHeader.classList.contains('active')) {
            elHeader.classList.add('active');
            elHeaderMenuToggle.setAttribute("aria-expanded", "true");
        }else{
            elHeader.classList.remove('active');
            elHeaderMenuToggle.setAttribute("aria-expanded", "false");
        }
    });

}

// Sous menu mobile
const elSubMenu = document.querySelector('#submenu');
if(elSubMenu){
    const elSubMenuToggle = document.querySelector('#submenuToggle');
    elSubMenuToggle.addEventListener("click", ()=>{
        if (!elSubMenu.classList.contains('active')) {
            elSubMenu.classList.add('active');
            elSubMenuToggle.setAttribute("aria-expanded", "true");
        }else{
            elSubMenu.classList.remove('active');
            elSubMenuToggle.setAttribute("aria-expanded", "false");
        }
    });
}

// Menu thèmes mobile
const elThemeMenu = document.querySelector('#themeMenu');
if(document.querySelector('#themeMenu')){
    const elThemeMenuToggle = document.querySelector('#themeMenuToggle');
    elThemeMenuToggle.addEventListener("click", ()=>{
        if (!elThemeMenu.classList.contains('active')) {
            elThemeMenu.classList.add('active');
            elThemeMenuToggle.setAttribute("aria-expanded", "true");
        }else{
            elThemeMenu.classList.remove('active');
            elThemeMenuToggle.setAttribute("aria-expanded", "false");
        }
    });
}


if(document.querySelector('#headerLastLink')){
    const elMenuLastLink = document.querySelector('#headerLastLink');
    const elMenuPreLastLink = document.querySelector('#headerPreLastLink');
    const elSkipLink = document.querySelector('#skipLink');
    document.onkeydown = (e) => {
        if(document.activeElement.id == 'headerLastLink'){
            if(e.keyCode === 9 && e.shiftKey) {
                elMenuPreLastLink.focus();
                return false;
            }else if(e.keyCode === 9){
                elSkipLink.focus();
                return false;
            }else{
                return true;
            }
        }
    }
}
